import { useFeatureGate } from '@statsig/react-bindings';

export function useFeedbackEnabled(): boolean {
  const { value } = useFeatureGate('feedback_fab');
  return value;
}
